/*
//-------------------------------------------------------
//   Copyright (c) 2020 Templa Computer Systems Ltd
//
//   App:        EmployeePortal.UI
//   Object:     DateTime.js
//   Details:    DateTime.js
//
//
// Log      Date   By  Scan Description
// -----  -------- --- ---- ------------------------------
// 108238 10/06/20 JC       Added
// 112846 13/04/21 JC  M01  Added UTC support
// WI3713 06/02/24 JC  M02JC    Extended UTC support
//-------------------------------------------------------
*/

import React, { Component } from 'react';
import { utils } from '../utils/utils';
import * as Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';
import moment from 'moment';
import Moment from 'react-moment';
import { dateTimeTypes } from '../constants/DateTimeTypes';

class DateTime extends Component {

    render() {
        const { componentKey, componentName, className, dateTimeType, value, onBlur, onChange, disabled, disabledFormat,
            dateIsUtc } = this.props; //M02JC

        //get the default formats
        const globalsDateTimeFormat = utils.getDateTimeFormat()
        const globalsDateFormat = utils.getDateFormat()
        const globalsTimeFormat = utils.getTimeFormat()

        //if no component disabled passed in, default to false
        let localDisabled = (disabled === undefined ? false : disabled);

        //default close on select to false
        let closeOnSelect = false;

        //default to global values
        let dateTimeFormat = globalsDateTimeFormat;
        let dateFormat = globalsDateFormat;
        let timeFormat = globalsTimeFormat;

        if (dateTimeType === dateTimeTypes.date) {
            //if using date only, set up control as such
            dateTimeFormat = globalsDateFormat;
            dateFormat = globalsDateFormat;
            timeFormat = false;
            closeOnSelect = true; // set close on select to true
        }
        else if (dateTimeType === dateTimeTypes.time) {
            //if using time only, set up control as such
            dateTimeFormat = globalsTimeFormat;
            dateFormat = false;
            timeFormat = globalsTimeFormat;
            closeOnSelect = true; // set close on select to true
        }

        //handle blank sting as null in passed in value
        let localValue = (value === "" ? null : value);

        //M02JC handle missing dateIsUTC
        let localDateIsUtc = (dateIsUtc === undefined ? false : dateIsUtc);

        //show different component dependent on whether enabled or disabled
        if (localDisabled) {

            //got an override disabled format?
            if (disabledFormat !== undefined) {
                dateTimeFormat = disabledFormat;
            }

            //disabled with date value - show react-moment
            if (localValue !== null) {

                return (
                    <Moment
                        date={localValue}
                        format={dateTimeFormat}
                        utc={localDateIsUtc} //M02JC
                    />
                );
            }
            //disabled without date value - nothing
            else { return [] }
        }
        else {//enabled - show react-dateime

            //if local value is not null, construct a date using moment and format with date time format
            if (localValue !== null) { localValue = moment.utc(value).format(dateTimeFormat) } //M01

            return (<Datetime inputProps={{
                className: className
            }}
                key={componentKey}
                name={componentName}
                value={localValue}
                onBlur={onBlur}
                onChange={onChange}
                dateFormat={dateFormat}
                timeFormat={timeFormat}
                closeOnSelect={closeOnSelect}
                utc={true} //M01
            />
            );
        }
    }
}

export default DateTime; 
